// import hooks
import { assoc, evolve, fromPairs, isEmpty, map, pipe } from 'ramda';

//import types
import {
  AdminFunction,
  FunctionFlag,
  FunctionFormValues
} from '../AdminFunctions.types';

//import utils
import { converterForDate } from 'utils/date';

/** This function converts the values from the administration/maintenance/functions/{rowId} endpoint */
export const useGetRowDataConverter: (response) => FunctionFormValues = pipe(
  evolve({
    valid: evolve({
      from: (value) => (value ? new Date(value) : null), // convert to date
      to: (value) => (value ? new Date(value) : null) // convert to date
    }),
    flags: pipe(
      map<string, [string, boolean]>((value) => [value, true]),
      fromPairs
    )
  }),
  assoc('wagePerHour', 0) as any
);

export const tableDataConverter = (data: AdminFunction[]) => {
  return !isEmpty(data)
    ? data.map((adminFunction) => ({
        ...adminFunction,
        functionGroup: adminFunction.parentFunctionDescription,
        isGroup: adminFunction.flags.includes(FunctionFlag.FUNCTION_GROUP),
        noPicker: adminFunction.flags.includes(FunctionFlag.REQUEST_EXCLUDE),
        excludeCapPlan: adminFunction.flags.includes(
          FunctionFlag.CAPPLAN_EXCLUDE
        ),
        noBUH: adminFunction.flags.includes(FunctionFlag.BUH_BLOCKED),
        noBonus: adminFunction.flags.includes(FunctionFlag.BONUS_BLOCKED),
        includeInKidsRatio: adminFunction.flags.includes(
          FunctionFlag.INCLUDE_IN_KIDS_RATIO
        ),
        leaveBlocked: adminFunction.flags.includes(FunctionFlag.LEAVE_BLOCKED),
        salaryBlocked: adminFunction.flags.includes(
          FunctionFlag.SALARY_BLOCKED
        ),
        overlap: adminFunction.flags.includes(
          FunctionFlag.DUTY_OVERLAP_ALLOWED
        ),
        from: converterForDate(new Date(adminFunction.valid.from)),
        to: converterForDate(new Date(adminFunction.valid.to))
      }))
    : [];
};
